import {connect} from 'react-redux';
import _ from 'lodash';
import {ToggleableComponent} from 'app-ui-componentlibrary/dist/componentLibrary/layout/ToggleableComponent';

export const mapStateToProps = (state) => {
  const toggles = _.get(state, 'toggles.toggles');
  const loading = _.get(state, 'toggles.loading');
  return {
    toggles,
    loading,
  };
};

export default connect(mapStateToProps)(ToggleableComponent);
